import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import { App } from './App.js';

const container = document.getElementById('root');
if (!container) {
  // Message technique, jamais affiché à un élève : il reste en anglais, comme le
  // reste du code. Tout ce qu'un élève lit vient du contenu ou de textes-interface.
  throw new Error('Root element #root not found.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
